export const formatBRL = (value?: number | null) =>
  value
    ? parseFloat(value as any as string).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      })
    : "A definir";

export const formatPercentage = (value: number) => {
  return value > 0 && value < 1 ? `${value * 100}%` : `${value}%`;
};

export const convertPercentageToDecimal = (value?: number) =>
  value !== undefined && value >= 1 ? value / 100 : value;

export const convertPercentageToNormal = (value: number) =>
  value !== undefined && value < 1 ? value * 100 : value;

// Helper for handling comma decimal separators
export const preprocessNumber = (val: unknown) => {
  if (typeof val === "string") {
    const value = val.replace(/,/g, ".");
    return parseFloat(value) || undefined;
  }

  return val || undefined;
};
